import React from 'react';
import { Link } from 'gatsby';
import Logo from '../../static/icons/_inline-svg/collex-full-black.svg';

const MyLadsLogo = () => {
    return (
        <Link to="/">
            <Logo className="logo w-32 h-14"></Logo>
        </Link>
    );
};

export default MyLadsLogo;
